const __WEBPACK_NAMESPACE_OBJECT__ = require("@azure/web-pubsub-client");